import { createSlice } from '@reduxjs/toolkit'
import { apiCallBegan } from '../api'
import { credentialMonitoringInitialState } from '../initialState/credentialMonitoringState'
import { onFilterByUpdate, onSortCriteriaUpdate, onResetTotal, onPageChange, onParamsUpdate } from '../filters'

const slice = createSlice({
    name: 'credentialMonitoring',
    initialState: credentialMonitoringInitialState,
    reducers: {
        riskProfilesRequested: (credentialMonitoring) => {
            credentialMonitoring.loading = true
            credentialMonitoring.error = null
        },
        riskProfilesSuccess: (credentialMonitoring, action) => {
            credentialMonitoring.loading = false
            credentialMonitoring.data.riskProfiles = action.payload.response.data.slice(0, credentialMonitoring.displaySize);
            credentialMonitoring.isLastPage = action.payload.response.data.length <= credentialMonitoring.displaySize;
            credentialMonitoring.errors = action.payload.response.errors
        },
        riskProfilesFailure: (credentialMonitoring, action) => {
            credentialMonitoring.loading = false
            credentialMonitoring.error = action.payload
            credentialMonitoring.data.riskProfiles = []
            credentialMonitoring.errors = []
        },

        setFilterBy: (credentialMonitoring, action) => {
            credentialMonitoring.filterBy = action.payload;
        },

        setSortBy: (credentialMonitoring, action) => {
            credentialMonitoring.sortBy = action.payload;
        },

        resetCredentialData: (credentialMonitoring) => {
            credentialMonitoring.data = credentialMonitoringInitialState.data
            credentialMonitoring.errors = credentialMonitoringInitialState.errors
            credentialMonitoring.loading = credentialMonitoringInitialState.loading
            credentialMonitoring.error = credentialMonitoringInitialState.error
        },

        riskProfilesDetailRequested: (credentialMonitoring, action) => {
            credentialMonitoring.selectedRiskProfileLoading = true
            credentialMonitoring.error = null
        },

        riskProfileDetailSuccess: (credentialMonitoring, action) => {
            credentialMonitoring.selectedRiskProfileLoading = false
            credentialMonitoring.data.selectedRiskProfile = action.payload.response.data;
            credentialMonitoring.errors = action.payload.response.errors
        },

        riskProfileDetailFailure: (credentialMonitoring, action) => {
            credentialMonitoring.selectedRiskProfileLoading = false
            credentialMonitoring.error = action.payload
            credentialMonitoring.data.selectedRiskProfile = []
            credentialMonitoring.errors = []
        },

        setPageNo: (credentialMonitoring, action) => {
            credentialMonitoring.pageNo = action.payload.pageNo;
        }
    }
})

export const {
    riskProfilesRequested,
    riskProfilesSuccess,
    riskProfilesFailure,
    resetCredentialData,
    riskProfilesDetailRequested,
    riskProfileDetailSuccess,
    riskProfileDetailFailure,
    setFilterBy,
    setSortBy,
    setPageNo
} = slice.actions

export default slice.reducer

// Action creators
export const loadRiskProfiles = (customerId, filterBy, sortBy, pageNo, pageSize) => {
    return apiCallBegan({
        urlPath: `/customers/${customerId}/risk-profiles?filterBy=${filterBy}&sortBy=${sortBy}&pageNo=${pageNo}&pageSize=${pageSize}`,
        method: 'GET',
        onStart: riskProfilesRequested.type,
        onSuccess: riskProfilesSuccess.type,
        onError: riskProfilesFailure.type,
    })
}

export const loadRiskProfileById = (customerId, userId) => {
    return apiCallBegan({
        urlPath: `/customers/${customerId}/risk-profiles/${userId}`,
        method: 'GET',
        onStart: riskProfilesDetailRequested.type,
        onSuccess: riskProfileDetailSuccess.type,
        onError: riskProfileDetailFailure.type,
    })
}


